import { AsyncPipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';

import { MatButtonModule } from '@angular/material/button';
import { TranslateModule } from '@ngx-translate/core';
import { Observable } from 'rxjs';

import { Required } from '@data-terminal/utils/decorators';
import { TimeFormatterPipeModule } from '@data-terminal/utils/pipes';

@Component({
    imports: [TranslateModule, MatButtonModule, TimeFormatterPipeModule, AsyncPipe],
    selector: 'data-terminal-inactivity-timer',
    templateUrl: './inactivity-timer.component.html',
    styleUrls: ['./inactivity-timer.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class InactivityTimerComponent {
    @Input()
    @Required()
    timer$!: Observable<number> | undefined;

    @Input()
    @Required()
    machineId!: string;

    @Output()
    primaryButtonClick = new EventEmitter<void>();

    @Output()
    secondaryButtonClick = new EventEmitter<void>();

    onPrimaryButtonClick(): void {
        this.primaryButtonClick.emit();
    }

    onSecondaryButtonClick(): void {
        this.secondaryButtonClick.emit();
    }
}
